import React, { useState, useEffect } from "react";
import "./kunstgalerie.css";

function importAll(r) {
  return r.keys().map(r);
}

const images = importAll(
  require.context("../../img", false, /\.(png|jpe?g|svg)$/)
);

function Kunstgalerie() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(images.length); // standaard alles tonen

  // Check schermgrootte bij laden en bij resize
  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth <= 768;
      setItemsPerPage((prevItemsPerPage) => {
        const newItemsPerPage = isMobile ? 8 : images.length;
        if (prevItemsPerPage !== newItemsPerPage) {
          setCurrentPage(1); // reset currentPage alleen als itemsPerPage verandert
          return newItemsPerPage;
        }
        return prevItemsPerPage;
      });
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Scroll to top when currentPage changes (fix iPhone scrolling issue)
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentPage]);

  // Bereken welke afbeeldingen getoond moeten worden
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentImages = images.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(images.length / itemsPerPage);

  return (
    <>
      <div className="masonry-gallery">
        {currentImages.map((src, index) => (
          <img
            key={indexOfFirstItem + index}
            src={src}
            alt={`kunstgalerie-${index}`}
            className="masonry-image"
            onClick={() => setSelectedImage(src)}
          />
        ))}
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Vorige
          </button>
          <span>
            Pagina {currentPage} / {totalPages}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            Volgende
          </button>
        </div>
      )}

      {selectedImage && (
        <div
          className="lightbox-overlay"
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="Vergrote weergave"
            className="lightbox-image"
          />
        </div>
      )}
    </>
  );
}

export default Kunstgalerie;
